import { render, staticRenderFns } from "./MaterialsPrices.vue?vue&type=template&id=5e1f2a0c&scoped=true&"
import script from "./MaterialsPrices.vue?vue&type=script&lang=js&"
export * from "./MaterialsPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f2a0c",
  null
  
)

export default component.exports